import React, { BaseSyntheticEvent } from 'react'
import { IonButton, IonCol, IonRow } from '@ionic/react'
import { IOption, IOptions } from '../../common/common.types'
import './SelectButtons.component.css'

interface ISelectButtonsProps {
  label: string
  dataTestId: string
  options: IOptions
  selectAction: (option?: IOption, dispatchData?: any) => void
  selectedID?: IOption | null
  dispatchData?: any
}

const SelectButtons: React.FC<ISelectButtonsProps> = (props: ISelectButtonsProps) => {
  const { label, dataTestId, options, selectAction, selectedID, dispatchData } = props

  const selectOption = (e: BaseSyntheticEvent, option: IOption, dispatchData: any) => {
    e.preventDefault()
    selectAction(option, dispatchData)
  }

  return (
    <>
      <section>
        <header className='select-button-header'>{label}</header>
        <IonRow>
          {options.map((option) => (
            <IonCol className='picklist' key={option.id}>
              <IonButton
                data-testid={dataTestId + option.id}
                id='select-buttons-button'
                expand='block'
                size='small'
                fill={option.id === selectedID?.id ? 'solid' : 'outline'}
                color={option.id === selectedID?.id ? 'primary' : ''}
                className={option.id === selectedID?.id ? '' : 'clearButton'}
                onClick={(e) => selectOption(e, option, dispatchData)}>
                {option.name}
              </IonButton>
            </IonCol>
          ))}
        </IonRow>
      </section>
    </>
  )
}
export default SelectButtons
